<template>
  <ion-row
    @click="isOpen = !isOpen"
    class="c-collapsible ion-align-items-center u-cursor-pointer"
  >
    <ion-col>
      <slot name="title"></slot>
    </ion-col>
    <ion-col size="auto">
      <ion-icon :icon="isOpen ? chevronUp : chevronDown"></ion-icon>
    </ion-col>
  </ion-row>
  <div v-if="isOpen">
    <slot></slot>
  </div>
</template>

<script>
import { IonRow, IonCol, IonIcon } from "@ionic/vue";
import { chevronDown, chevronUp } from "ionicons/icons";

export default {
  components: {
    IonRow,
    IonCol,
    IonIcon,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  setup() {
    return { chevronDown, chevronUp };
  },
};
</script>

<style></style>
